<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="/layout/info-pool?id=4">信息交流</router-link></li>
                <li><router-link :to="parentLink">{{ infoPoolTag }}</router-link></li>
                <li class="currentNode"><a>{{ infoPoolTag }}详情</a></li>
            </ul>
            <div class="page-main">
                <h3>{{ title }}</h3>
                <div class="page-main-tp">
                    <p  class="info-tool-tag">
                        <img src="@/assets/image/infoPool/pdf.png" />
                        <span>{{ infoPoolTag }}</span>
                    </p>
                    <button class="download-btn" @click="getProjectDown()">
                        <img src="@/assets/image/infoPool/download.png" />
                        <span>会员免费下载</span>
                    </button>
                </div>
                <el-divider></el-divider>
                <div class="page-main-btm content-detail" v-html="content">
                    
                </div>
            </div>
        </div>
        <el-dialog
            title=""
            :visible.sync="downloadDialogVisible"
            width="416px">
            <h3><i class="el-icon-warning-outline" style="color:#E6A23C;margin-right: 10px;margin-bottom:10px;"></i>{{ downloadDialogTitle }}</h3>
            <p style="padding-left:30px;">{{ downloadDialogContent }}</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="downloadDialogVisible = false" size="medium">取 消</el-button>
                <el-button type="primary" @click="goLogin()" size="medium">去登录</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    getProjectDetail,
    getPlolicyDetail,
    getProjectDown
} from '@services/indexService.js'
import { getCookie } from '@/assets/utils/cookie.js'
export default {
    name:"",
    data() {
        return {
            detailId: '',
            page: '',
            title: '',
            accountId: '',
            content: '',
            infoPoolTag: '',
            downloadUrl: '',
            parentNav: '',
            parentLink: '',
            downloadDialogVisible: false,
            downloadDialogTitle: '请登录会员，上传专报信息后，免费下载',
            downloadDialogContent: '会员每上传1条专报信息，可下载5条专报信息'
        }
    },
    created() {
        this.detailId = this.$route.query.id;
        this.page = this.$route.query.page;
        this.getProjectDetail(this.detailId);
    },
    methods: {
        traverseTitle() {
            if (this.infoPoolTag === '智库信息'){
                this.parentLink = `/layout/info-pool?id=1&page=${thias.page}`;
            } else if (this.infoPoolTag === '批示专报信息'){
                this.parentLink = `/layout/info-pool?id=2&page=${thias.page}`;
            } else if (this.infoPoolTag === '专报信息') {
                this.parentLink = `/layout/info-pool?id=3&page=${thias.page}`;

            } else {
                this.parentLink = `/layout/info-pool?id=4&page=${thias.page}`;
            }
        },
        getProjectDetail(id) {
            let params = {
                id: id
            };
            getProjectDetail(params).then(res => {
                console.log(res);
                if (res.Code == 1 && res.Data.length!==0) {
                    this.title = res.Data.Name;
                    this.accountId = res.Data.AccountId;
                    this.content = res.Data.ProjectDesc;
                    this.infoPoolTag = res.Data.Invest;
                    this.traverseTitle();
                } else {
                    this.$message.error("信息交流详情访问请求失败");
                }
            })
        },
        getPlolicyDetail (id) {
            let params = {
                id: id
            };
            getProjectDetail(params).then(res => {
                console.log(res);
                if (res.Code == 1 && res.Data.length!==0) {
                    this.title = res.Data.Name;
                    this.accountId = res.Data.AccountId;
                    this.content = res.Data.ProjectDesc;
                    this.infoPoolTag = res.Data.Invest;
                    this.traverseTitle();
                } else {
                    this.$message.error("信息交流详情访问请求失败");
                }
            })
        },
        getProjectDown() {
            let accountId = getCookie('accountId');
            console.log(accountId)
            if (!accountId) {
                this.downloadDialogVisible = true;
                return;
            }
            let params = {
                id: this.detailId,
                accountid: this.accountId,
            };
            getProjectDown(params).then((res) => {
                // console.log(res);
                if (res.Code == 1) {
                    this.downloadUrl = res.Data;
                    window.open(this.downloadUrl, '_blank');
                } else {
                    this.$message.error('访问下载请求失败');
                }
            });
        },
        getProjectDownOther() {
            let accountId = getCookie('accountId');
            if (!accountId) {
                this.downloadDialogTitle = '登录会员，免费下载';
                this.downloadDialogContent = '';
                this.downloadDialogVisible = true;
                return;
            }
            let params = {
                id: this.detailId,
                accountid: this.accountId,
            };
            getProjectDown(params).then((res) => {
                // console.log(res);
                if (res.Code == 1) {
                    this.downloadUrl = res.Data;
                    window.open(this.downloadUrl, '_blank');
                } else {
                    this.$message.error('访问下载请求失败');
                }
            });
        },
        handleCurrentChange(pageNum) {

        }
    }
}
</script>

<style scoped>
.page-main{
    display: block;
    background: #fff;
    padding: 60px 50px;
    box-sizing: border-box;
}
.page-main h3 {
    color: #262626;
    font-size: 22px;
    text-align: left;
}
.page-main-tp,
.info-tool-tag {
    display:flex;
    justify-content: space-between;
    align-items: center;
}
.info-tool-tag img{
    width: 22px;
    height: 22px;
    margin-right:5px;
}
.info-tool-tag span{
    background: #0090F0;
    font-size: 12px;
    color: #fff;
    padding: 2px 4px;
    margin-right: 10px;
}
.download-btn {
    width: 129px;
    height: 30px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: #116EBA;
    color:#fff;
    font-size: 14px;
    cursor: pointer;
    text-align: center;
    box-sizing: border-box;
    transition: all 0.36s;
    border:none;
}
.download-btn img {
    width: 14px;
    height: 14px;
}
.page-content {
    width: 100% !important;
}
.page-main-btm p {
    margin-bottom: 20px;
    color: #4E5969;
}
</style>